const nextIdentifyConstants = {
  NEXT_IDENTIFY_VALIDATION: 'NEXT_IDENTIFY_VALIDATION'
};

export default nextIdentifyConstants;
